/**
 * Returns a promise that resolves to the text contained in the
 * fetched document.
 * @param url The URL where the document is located.
 * @returns {Promise<string>} A promise that resolves to the text
 * contained in the fetched document.
 * @throws Error if the fetch operation doesn't succeed.
 */
export default function fetchDoc(url) {
  return fetch(url).then(response => {
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    return response.text();
  });
}
